export interface Role {
	id: string;
	name: string;
	permissions: PermissionRecord[];
}

export namespace Permissions {
	export enum Collaborators {
		VIEW = 'COLLABORATORS_VIEW', // list/nomina, docs read
		MANAGE = 'COLLABORATORS_MANAGE', // create/edit/reactivate/deactivate, photo
		DOCS_MANAGE = 'COLLABORATORS_DOCS_MANAGE', // generate link, upload, link, delete, download
		DOCS_VIEW = 'COLLABORATORS_DOCS_VIEW', // docs read only
		MANUAL_RECORD = 'COLLABORATORS_MANUAL_RECORD', // do manual record
		PROXY_RECORD = 'COLLABORATORS_PROXY_RECORD', // do proxy check-in/check-out on behalf of another collaborator
	}

	export enum QontactPoints {
		VIEW = 'QP_VIEW', // list/view/summary
		MANAGE = 'QP_MANAGE', // create/update/delete
	}

	export enum Shifts {
		VIEW = 'SHIFTS_VIEW', // view shifts and recipes
		MANAGE = 'SHIFTS_MANAGE', // create/edit/delete recipes
	}

	export enum Alerts {
		VIEW = 'ALERTS_VIEW', // list
		MANAGE = 'ALERTS_MANAGE', // create/delete subscriptions
	}

	export enum Notifications {
		VIEW = 'NOTIFICATIONS_VIEW', // list/view
		MANAGE = 'NOTIFICATIONS_MANAGE', // mark as read
	}

	export enum Communications {
		MANAGE = 'COMMS_MANAGE',
	}

	export enum Requests {
		VIEW = 'REQUESTS_VIEW', // list/read pending + processed
		DECIDE = 'REQUESTS_DECIDE', // approve/reject
	}

	export enum Novelties {
		VIEW = 'NOVELTIES_VIEW', // list, report
		VIEW_ABSENTS = 'NOVELTIES_VIEW_ABSENTS', // view absents
		MANAGE = 'NOVELTIES_MANAGE', // create/disable/update
		MANAGE_ABSENTS = 'NOVELTIES_MANAGE_ABSENTS', // resolve absents
		CONFIG = 'NOVELTIES_CONFIG', // days/holidays/novelties types config
	}

	export enum Admin {
		VIEW_PRESENTEEISM = 'VIEW_PRESENTEEISM', // view presenteeism dashboard
		CONFIG_DASHBOARD_USERS = 'CONFIGURE_DASHBOARD_USERS', // configure users for dashboard
		CONFIG_ROLES = 'CONFIGURE_ROLES', // create/edit/delete roles
		REPORTS_VIEW = 'REPORTS_VIEW', // view reports
	}


	export type Id =
		| Collaborators
		| QontactPoints
		| Shifts
		| Alerts
		| Notifications
		| Communications
		| Requests
		| Novelties
		| Admin;

	// Grouped ALL dictionary
	export const ALL = {
		Collaborators: Object.values(Collaborators),
		QontactPoints: Object.values(QontactPoints),
		Shifts: Object.values(Shifts),
		Novelties: Object.values(Novelties),
		Alerts: Object.values(Alerts),
		Notifications: Object.values(Notifications),
		Communications: Object.values(Communications),
		Requests: Object.values(Requests),
		Admin: Object.values(Admin),
	} as const;
}

export interface PermissionRecord {
  id: Permissions.Id | string;
  effect: 'allow';
  expiresAt?: number; // timestamp in ms
}


export interface RoleAssignment {
    userId: string;
    roleId: string;
    assignedAt: number; // timestamp in ms
}